import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const selectedAccountAtom = atom({
	key: "selectedAccountAtom",
	default: null,
	effects_UNSTABLE: [persistAtom],
});
